import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { TextareaField } from '../../../../utils/InputField';
import { ApiMakeOngoingItem } from '../ServicesManageOperation';

function MakeOngoingModal({ data, handleReload }) {
    const { setMessage, setConfirm } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        ServiceId: data?.id,
        Note: ''
    });

    // -- Handle Form Data
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    // -- Handle Form Submit
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        ApiMakeOngoingItem(data?.id, formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                setConfirm(null);
                handleReload();
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-2">
            <p className="text-base font-normal">
                Are you sure you want to make this service ongoing??
            </p>
            <TextareaField
                name="Note"
                placeholder="Write your notes....."
                formData={formData}
                onChange={handleChange}
                className="h-20 *:resize-none"
            />
            <p className="text-error text-xs text-left ">This field is required.</p>
            <div className="w-full flex justify-end items-center gap-2">
                <ButtonCancel title="Cancel" onClick={() => setConfirm(null)} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default MakeOngoingModal;
